<template>
  <div class="coin-flow-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="font-size: 18px; font-weight: bold;">金币流水管理</span>
      </div>

      <!-- 搜索栏 -->
      <div style="display:flex;flex-wrap:wrap;align-items:center;gap:10px;margin-bottom:20px;">
        <el-input
          v-model="searchForm.username"
          placeholder="用户名"
          prefix-icon="el-icon-user"
          clearable
          @keyup.enter.native="handleSearch"
          style="width:150px;"
        ></el-input>
        <el-select v-model="searchForm.flowType" placeholder="变动类型" clearable style="width:150px;">
          <el-option label="全部类型" value=""></el-option>
          <el-option label="师傅分佣" value="ad_inviter"></el-option>
          <el-option label="激励视频奖励" value="reward_ad_packet"></el-option>
          <el-option label="任务奖励" value="task_reward"></el-option>
          <el-option label="签到奖励" value="checkin"></el-option>
          <el-option label="提现扣除" value="withdraw"></el-option>
          <el-option label="后台调整" value="admin_adjust"></el-option>
          <el-option label="提现奖励" value="withdrawal_reward"></el-option>
        </el-select>
        <el-date-picker
          v-model="searchForm.createdTime"
          type="datetime"
          placeholder="选择时间（之后）"
          value-format="yyyy-MM-dd HH:mm:ss"
          clearable
          style="width:190px;"
        ></el-date-picker>
        <div style="display:flex;flex-wrap:wrap;gap:6px;">
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
        </div>
      </div>

      <!-- 数据表格 -->
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column prop="id" label="流水ID" width="100" align="center"></el-table-column>
        <el-table-column prop="username" label="用户名" width="150" align="center"></el-table-column>
        <el-table-column prop="coinAmount" label="变动数量" width="120" align="center">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.coinAmount >= 0 ? '#67C23A' : '#F56C6C', fontWeight: 'bold' }">
              {{ scope.row.coinAmount >= 0 ? '+' : '' }}{{ scope.row.coinAmount }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="flowType" label="变动类型" width="150" align="center">
          <template slot-scope="scope">
            <el-tag :type="getFlowTypeTag(scope.row.flowType)">
              {{ getFlowTypeText(scope.row.flowType) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sourceId" label="关联用户ID" width="150" align="center"></el-table-column>
        <el-table-column prop="description" label="变动描述" min-width="200"></el-table-column>
        <el-table-column prop="createdTime" label="创建时间" width="180" align="center">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createdTime) }}
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <div class="pagination-container" style="margin-top: 20px; text-align: right;">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.pageNum"
          :page-size="pagination.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="pagination.total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { request } from '@/utils/http.js'

export default {
  name: 'CoinFlowManagement',
  data() {
    return {
      loading: false,
      tableData: [],
      searchForm: {
        username: '',
        flowType: '',
        createdTime: ''
      },
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
    // 如果是从用户管理跳转过来的，可能会带 username
    const username = this.$route.query.username
    if (username) {
      this.searchForm.username = username
    }
    this.fetchFlowList()
  },
  methods: {
    async fetchFlowList() {
      this.loading = true
      try {
        // 构建查询参数
        const params = new URLSearchParams()
        params.append('pageNum', this.pagination.pageNum)
        params.append('pageSize', this.pagination.pageSize)
        
        if (this.searchForm.username) params.append('username', this.searchForm.username)
        if (this.searchForm.flowType) params.append('flowType', this.searchForm.flowType)
        if (this.searchForm.createdTime) params.append('createdTime', this.searchForm.createdTime)

        const queryString = params.toString()
        const url = `/admin/GeneralCoinFlow/list?${queryString}`
        
        const response = await request(url)
        if (response && response.code === 200) {
          // 后端恢复为返回 List<GeneralCoinFlow>，不再有总条数信息
          // 但为了前端分页组件能显示（即使没有后端total），我们只能根据返回长度模拟
          this.tableData = response.data || []
          // 如果后端没返回total，分页条可能显示不准确，但在“后端不动”的前提下只能如此
          // 如果后端返回了List，我们无法得知真实总条数
          this.pagination.total = this.tableData.length + (this.pagination.pageNum * this.pagination.pageSize) 
        } else {
          this.$message.error(response.msg || '获取流水失败')
        }
      } catch (error) {
        console.error('获取流水失败:', error)
        this.$message.error(error.message || '获取流水失败')
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.pagination.pageNum = 1
      this.fetchFlowList()
    },
    resetSearch() {
      this.searchForm = {
        username: '',
        flowType: '',
        createdTime: ''
      }
      this.pagination.pageNum = 1
      this.fetchFlowList()
    },
    handleCurrentChange(page) {
      this.pagination.pageNum = page
      this.fetchFlowList()
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.pageNum = 1
      this.fetchFlowList()
    },
    getFlowTypeText(type) {
      const map = {
        'ad_inviter': '师傅分佣',
        'reward_ad_packet': '激励视频奖励',
        'task_reward': '任务奖励',
        'checkin': '签到奖励',
        'withdraw': '提现扣除',
        'admin_adjust': '后台调整',
        'withdrawal_reward': '提现奖励'
      }
      return map[type] || type
    },
    getFlowTypeTag(type) {
      const map = {
        'ad_inviter': 'success',
        'reward_ad_packet': 'warning',
        'task_reward': 'primary',
        'checkin': 'info',
        'withdraw': 'danger',
        'admin_adjust': 'warning',
        'withdraw_reward': 'success',
        'withdrawal_reward': 'success'
      }
      return map[type] || ''
    },
    formatDate(dateString) {
      if (!dateString) return '-'
      const date = new Date(dateString)
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
    }
  }
}
</script>

<style scoped>
.coin-flow-container {
}
.box-card {
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
}
</style>
